import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4.196a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 1 0 0-16.5m-9.75 8.25c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75a9.75 9.75 0 0 1-9.75 9.75 9.75 9.75 0 0 1-9.75-9.75m8-4.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 1 1-2.5 0m-1 3.21a.75.75 0 0 1 .75-.75h2.25a1 1 0 0 1 1 1v5H15a.75.75 0 1 1 0 1.5h-5a.75.75 0 1 1 0-1.5h1.75v-4.5H10a.75.75 0 0 1-.75-.75"
}));
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;